<template>
  <div class="Dashboard full-height">
    <transition class="full-height">
      <keep-alive :include="$route.meta.include">
        <router-view />
      </keep-alive>
    </transition>

    <van-row
      type="flex"
      align="center"
      class="nav-tabbar shadow"
    >
      <van-col
        v-for="(tab,index) in tabbarList"
        :key="tab.link"
        :span="(tabbarList.length==4?6:((tabbarList.length == 5 && index == 2) ? 4 : 5))"
        @click.native="$router.push(tab.link)"
      >
        <van-image
          width="24"
          height="24"
          :src="tab.normalImg"
          v-show="hashAddr != tab.link"
        />
        <van-image
          width="24"
          height="24"
          :src="tab.activeImg"
          v-show="hashAddr == tab.link"
        />
        <div>{{ $t(tab.title) }}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>

import home from 'Components/Dynamic/yxsl/images/navbar/home.png'
import home1 from 'Components/Dynamic/yxsl/images/navbar/home1.png'
import user from 'Components/Dynamic/yxsl/images/navbar/user.png'
import user1 from 'Components/Dynamic/yxsl/images/navbar/user1.png'
import approval from 'Components/Dynamic/yxsl/images/navbar/approval.png'
import approval1 from 'Components/Dynamic/yxsl/images/navbar/approval1.png'
import triplist from 'Components/Dynamic/yxsl/images/navbar/triplist.png'
import allorder from 'Components/Dynamic/yxsl/images/navbar/allorder.png'
import allorder1 from 'Components/Dynamic/yxsl/images/navbar/allorder1.png'

import { mapGetters } from 'vuex'
import { localget } from 'Utils/storage.js'
import { Image as VanImage} from 'vant'

export default {
  name: 'Dashboard',
  components:{
    [VanImage.name]: VanImage,
  },
  data () {
    return {
      hashAddr: '/home'
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo'
    }),
    tabbarList(){
      let obj=[
        {
          link: '/home',
          title: 'A003',//首页
          normalImg: home,
          activeImg: home1
        },
        {
          link: '/allorder',
          title: 'A004',//行程
          normalImg: allorder,
          activeImg: allorder1
        },
        {
          link: '/tripList',
          title: '出差',
          normalImg: triplist,
          activeImg: triplist
        },
        {
          link: '/approvalList',
          title: 'A006',//审批
          normalImg: approval,
          activeImg: approval1
        },
        {
          link: '/userCenter',
          title: 'A007',//我的
          normalImg: user,
          activeImg: user1
        }
      ]
      if(this.userInfo.vipCorp){
        if(this.userInfo.vipCorp.bookStyle==1){
          obj.splice(2,1)
          return obj
        }
      }else{
        let userInfo = localget('userInfo')
        if(userInfo){
          this.$store.commit('SET_USERINFO',userInfo)
          //如果是单订模式 删除申请单的入口
          if(userInfo.vipCorp&&userInfo.vipCorp.bookStyle==1){
            obj.splice(2,1)
            return obj
          }
        }
      }
      return obj
    }
  },
  created () {
    this.hashAddr = this.$route.path
  },
  watch: {
    '$route.path': function (val) {
      if(val==='/allorder'){//默认进入订单列表中的 未出行
        this.$store.commit('SET_ORDERLISTPARAMS',{findType:'3'})
      }
      this.hashAddr = val
    }
  }
}
</script>

<style lang="less">
.Dashboard {
  .nav-tabbar {
    background-color: @color-background-white;
    position: fixed;
    left: 0px;
    bottom: 0px;
    right: 0px;
    height: 50px;
    // border-radius: @border-radius-sm;
    overflow: hidden;
    text-align: center;
    padding: 4px 0;
    line-height: 1;

    .normal {
      height: 26px;
    }

    .active {
      height: 26px;
    }
  }
}
</style>
